import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from '../../components/base/grid';
import { H1 } from '../../components/base/typography';
import Breadcrumbs from '../../components/breadcrumbs';
import DamageReportForm from '../../components/damageReportForm';
import pageWrapper from '../../hoc/pageWrapper';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';

interface Props {
	componentId: number;
	page: IPageViewModel;
}

const DamageReport: FC<Props> = ({ page }) => {
	const { t } = useTranslation('damageReport');
	return (
		<Container>
			<Breadcrumbs pageId={page.Id} />
			<H1 marginTop="4rem" marginBottom="4rem">{`${t('report-damage')}`}</H1>
			<p>{String(t('onlyIceland'))}</p>
			<DamageReportForm />
		</Container>
	);
};

export default pageWrapper(DamageReport);
